/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Invitation_Login_ActionInputs */

const es_co2_signup_invitation_login_action = /** @type {(inputs: Signup_Invitation_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

/**

* @param {Signup_Invitation_Login_ActionInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_invitation_login_action = /** @type {((inputs?: Signup_Invitation_Login_ActionInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Invitation_Login_ActionInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_invitation_login_action(inputs)
});